import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
    AllAvailability,
    Buttton,
    Cards,
} from "../../components";
import { useTranslation } from "react-i18next";
import { PiChat, PiHospital, PiPhone } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../redux/actions";
import { FaCaretRight } from "react-icons/fa";
import { ViewAllAvailability } from "../../components/modals";
import { useNavigate } from "react-router-dom";

const SpecialistList = ({ activeTab, radioAndSearch, credentialsSpecialist, setCredentialsSpecialist }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [credentials1, setCredentials1] = useState({
        appDate: "",
        appointmentType: 2,
        userTimeZone: "India Standard Time",
        currency: "EUR",
        clinicGuid: null,
        IsClinicSchedule: false,
    });
    const [showModal, setShowModal] = useState(false);
    const [availableSlotsMap, setAvailableSlotsMap] = useState({});
    const [doctorAppDates, setDoctorAppDates] = useState({});

    const postSearchAppointmentData = useSelector(
        (state) => state.patient.postSearchAppointmentData?.data
    );


    useEffect(() => {
        if (activeTab === "specialist-list") {
            dispatch(actionPatient.postSearchAppointment(credentialsSpecialist));
        }
    }, [activeTab, credentialsSpecialist, dispatch]);

    const shiftDateByWeeks = (baseDateStr, weekDiff) => {
        const baseDate = new Date(baseDateStr);
        baseDate.setDate(baseDate.getDate() + weekDiff * 5);
        return baseDate.toISOString().split("T")[0];
    };


    const handleAvailability = (doctorGuid, direction) => {
        const currentDate = doctorAppDates[doctorGuid] || credentialsSpecialist.appDate;
        const updatedDate = shiftDateByWeeks(currentDate, direction);

        const today = new Date().setHours(0, 0, 0, 0);
        if (direction < 0 && new Date(updatedDate) < today) return;

        const payload = {
            ...credentialsSpecialist,
            appDate: currentDate,
            appdate: updatedDate,
        };

        dispatch(
            actionPatient.postFetchNextAppointments(
                payload,
                doctorGuid,
                false,
                (error, response) => {
                    if (error) return;
                    if (response) {
                        setAvailableSlotsMap((prev) => ({
                            ...prev,
                            [doctorGuid]: response?.data?.result?.availableSlots,
                        }));
                        setDoctorAppDates((prev) => ({
                            ...prev,
                            [doctorGuid]: updatedDate,
                        }));
                    }
                }
            )
        );
    };


    // const handleDateChange = (date, allavailability) => {
    //     if (!date || isNaN(new Date(date).getTime())) return;

    //     const localDate = new Date(new Date(date).getTime() - new Date().getTimezoneOffset() * 60000);
    //     const formattedDate = localDate.toISOString().split("T")[0];

    //     setCredentialsSpecialist((prev) => ({
    //         ...prev,
    //         appDate: formattedDate,
    //     }));
    // };

    const handleClick = (doctorDetails) => {
        if (activeTab === "specialist-list") {
            navigate("/doctor-detail", {
                state: {
                    doctorDetails
                },
            })
        }
    }

    return (

        <Container className="exado-container" fluid>
            {radioAndSearch}


            <Row className="exado-row">
                <Col className="exado-col">
                    <h3 className="exado-title-three">{t("search_result")}</h3>
                    <p className="exado_body_text">
                        {postSearchAppointmentData?.result?.length || 0} {t("doctors_found")}
                    </p>
                </Col>
            </Row>


            <Row className="exado-row" md={1}>
                {postSearchAppointmentData?.result?.map((doctor, index) => (
                    <Col className="exado-col" fluid key={index}>
                        <Cards.HCardd
                            className="Hcardd2"
                            colClassNameImg="col-md-2"
                            colClassNameImg1="col-md-10"
                            imageSrc={doctor.doctorImage}
                            cardBody={
                                <>
                                    <aside className="aside lside">
                                        <div>
                                            <p className="exado_body_text_three text-uppercase physicianService">
                                                {doctor.physicianServices.map((Service, i) => (
                                                    <span key={i} className="physicianService-span">
                                                        {Service},
                                                    </span>
                                                ))}
                                            </p>
                                            <h3 className="exado-title-three specialist-name custom-cursor-pointer" onClick={() => handleClick(doctor)}>
                                                {doctor.firstName} {doctor.lastName}
                                            </h3>
                                            <div className="about-blk">
                                                <h5 className="exado_body_text_three">{t("about")}</h5>
                                                <p className="exado-title-six about-description">
                                                    Dr. Alex Smith is a board-certified cardiologist with over 15 years of experience
                                                    specializing in interventional cardiology. She is dedicated to patient-centered care and
                                                    wellness.
                                                </p>
                                            </div>
                                        </div>


                                        <div>
                                            <h5 className="exado_body_text_three">{t("price_list")}</h5>
                                            <ul className="price-list-ul">
                                                <li className="price-list-li">
                                                    <span className="exado-title-six">
                                                        <PiChat className="me-3" />
                                                        {t("book_an_appointments.per_sms")}
                                                    </span>
                                                    <span className="exado-title-six">
                                                        {doctor.userCurrency} {doctor.chatFees}
                                                    </span>
                                                </li>
                                                <li className="price-list-li">
                                                    <span className="exado-title-six">
                                                        <PiPhone className="me-3" />
                                                        {t("book_an_appointments.online_consultation")}
                                                    </span>
                                                    <span className="exado-title-six">
                                                        {doctor.userCurrency} {doctor.onlineAppointmentFees}
                                                    </span>
                                                </li>
                                                <li className="price-list-li">
                                                    <span className="exado-title-six">
                                                        <PiHospital className="me-3" />
                                                        {t("book_an_appointments.in_clinic_consultation")}
                                                    </span>
                                                    <span className="exado-title-six">
                                                        {doctor.userCurrency} {doctor.inclinicAppointmentFees}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </aside>


                                    <aside className="aside rside">
                                        <AllAvailability.AvailabilitySlotList
                                            availableSlot={availableSlotsMap[doctor.doctorGuid] || doctor.availableSlots}
                                            onPerClick={() => handleAvailability(doctor.doctorGuid, -1)}
                                            // onTimeClick={(time) => handleDateChange(time, true)}
                                            onNextClick={() => handleAvailability(doctor.doctorGuid, 1)}
                                        />
                                        <div className="d-flex justify-content-end">
                                            <Buttton.Buttton
                                                type="button"
                                                className="transparent"
                                                onClick={() => {
                                                    const today = new Date();
                                                    const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
                                                    const formattedDate = localDate.toISOString().split("T")[0];

                                                    // Uncomment and adjust if you want to use it
                                                    // setCredentialsSpecialist(prev => ({
                                                    //     ...prev,
                                                    //     appDate: formattedDate,
                                                    // }));
                                                }}
                                            >
                                                {t("view_avaiability")} <FaCaretRight />
                                            </Buttton.Buttton>
                                        </div>
                                    </aside>
                                </>
                            }

                        />
                    </Col>
                ))}
            </Row>
        </Container>




    );
};

export default SpecialistList;
